export const environment = {
  production: false,
  apiBaseUrl: 'https://api-dev.veralora.com',
  paddleEnv: 'sandbox',
  paddleToken: 'test_0b8d75ee6c2c49e91b944f463cc',
  paddleSuccessUrl: 'https://sender-dev.veralora.com/subscription-activated'
};
